/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxLightningBIcon24Regular = forwardRef('NatureFxLightningBIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.998 1.518c.821-1.046 2.502-.466 2.502.864V10h4.414c1.168 0 1.822 1.345 1.102 2.264l-8.014 10.218c-.821 1.047-2.502.466-2.502-.864v-7.617H5.086c-1.168 0-1.822-1.346-1.102-2.264l8.014-10.219ZM13 2.672 5.291 12.5H9.6a1.4 1.4 0 0 1 1.4 1.4v7.428l7.709-9.829H14.4a1.4 1.4 0 0 1-1.4-1.4V2.672Z" })));
});
